import styles from '@components/components/CmsComponents/components/CmsDownloadAccordion/CmsDownloadAccordion.module.scss';
import CmsFileList from '@components/components/CmsComponents/components/CmsFileList/CmsFileList.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Content } from '@wienenergiegithub/ui-next';

const CmsDownloadAccordion = ({
  headline = '',
  headingLevel = 2,
  isCard = true,
  items,
}) => (
  <Accordion
    className={styles.accordionWrapper}
    headingLevel={headingLevel}
    title={headline}
  >
    {items?.map(item => (
      <div key={item.id}>
        {!!item?.groupHeading && (
          <Content notResponsive size="md">
            {item.groupHeading}
          </Content>
        )}
        <div className={styles.cardsGroup}>
          <CmsFileList
            headingLevel={headingLevel + 1}
            isCard={isCard}
            isDownloadAccordion
            items={item.subItems}
          />
        </div>
      </div>
    ))}
  </Accordion>
);

CmsDownloadAccordion.propTypes = {
  headingLevel: PropTypes.number,
  headline: PropTypes.string,
  isCard: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      groupHeading: PropTypes.string,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          text: PropTypes.string,
          url: PropTypes.string,
          validFrom: PropTypes.shape({
            date: PropTypes.string,
          }),
        }),
      ),
    }),
  ).isRequired,
};

export default CmsDownloadAccordion;
